// Module
var code = "<p>Enable this setting to hide donut chart containing overall statistics regarding number of participants.</p> ";
// Exports
module.exports = code;